import { render, staticRenderFns } from "./AccommodationBookingsTable.vue?vue&type=template&id=2c45498a&"
import script from "./AccommodationBookingsTable.vue?vue&type=script&lang=js&"
export * from "./AccommodationBookingsTable.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationBookingsTable.vue?vue&type=style&index=0&id=2c45498a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports